export class FundType {
    id: number;
    name: string;
    description: string;
}
